export default __webpack_public_path__ + "static/media/elearning-demo.faa73ee4.mp3";